import React from "react";
import styled from "styled-components";

export const CriticalErrorFallback = () => (
    <ErrorContainer>
        <h1>Nånting gick väldigt snett.</h1>
        <p>Vänligen ladda om sidan.</p>
    </ErrorContainer>
);

export const ErrorContainer = styled.div`
    font-family: "Akkurat";
    display: flex;
    min-height: 100vh;
    width: 100%;
    padding: 24px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
`;
